interface VariablePillProps {
  variable: string;
  type?: 'name' | 'company' | 'other';
}

export function VariablePill({ variable, type = 'other' }: VariablePillProps) {
  const getColorClasses = () => {
    switch (type) {
      case 'name':
        return 'bg-[#1875FF]/10 text-[#1875FF] border-[#1875FF]/20';
      case 'company':
        return 'bg-green-100 text-green-700 border-green-200';
      default:
        return 'bg-purple-100 text-purple-700 border-purple-200';
    }
  };

  return (
    <span
      className={`inline-flex items-center px-2 py-0.5 rounded text-xs font-medium border ${getColorClasses()} transition-all hover:scale-105`}
    >
      {variable}
    </span>
  );
}

export function sanitizeDisplayContent(content: string): string {
  return content.replace(/\u2014/g, '');
}

export function parseContentWithVariables(content: string) {
  const sanitized = sanitizeDisplayContent(content);
  const variableRegex = /\{([^}]+)\}/g;
  const parts: Array<{ type: 'text' | 'variable'; content: string; variableType?: 'name' | 'company' | 'other' }> = [];
  let lastIndex = 0;
  let match;

  while ((match = variableRegex.exec(sanitized)) !== null) {
    if (match.index > lastIndex) {
      parts.push({
        type: 'text',
        content: sanitized.substring(lastIndex, match.index),
      });
    }

    const variable = match[0];
    const variableName = match[1].toLowerCase();

    let variableType: 'name' | 'company' | 'other' = 'other';
    if (variableName.includes('name') || variableName.includes('agent')) {
      variableType = 'name';
    } else if (variableName.includes('company')) {
      variableType = 'company';
    }

    parts.push({
      type: 'variable',
      content: variable,
      variableType,
    });

    lastIndex = match.index + match[0].length;
  }

  if (lastIndex < sanitized.length) {
    parts.push({
      type: 'text',
      content: sanitized.substring(lastIndex),
    });
  }

  return parts;
}
